<template>
  <div class="mockup-preview-model-3d">
    <slot name="stores"></slot>

    <div class="mockup__input">
      <label class="mockup__btn" :for="`previewModel3d${timestamp}`"
        >Upload Model 3d</label
      >
      <input
        type="file"
        v-show="false"
        :id="`previewModel3d${timestamp}`"
        ref="previewModel3d"
        @change="setPreviewModel3d"
        accept=".glb"
      />
    </div>
    <preview-model-3d :current="current.previewModel3d" />
  </div>
</template>

<script>
import PreviewModel3d from "./preview-model-3d/PreviewModel3d.vue";

export default {
  components: {
    PreviewModel3d,
  },
  props: {
    current: Object,
  },
  data() {
    return {
      timestamp: new Date().getTime(),
    };
  },
  methods: {
    setPreviewModel3d() {
      const file = this.$refs.previewModel3d.files[0];
      if (!file) return;
      this.current.addPreviewModel3d({ file });
      console.log(file, "file");
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-model-3d {
  display: grid;
  padding: 0 6px 6px;
  gap: 6px;
}
</style>
